import {connect} from 'react-redux';

import {getUser} from 'mattermost-redux/selectors/entities/users';
import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';
import {getPostOverrideIconURL} from 'features/posts/selectors/get_post_override_icon_url';

import {type GlobalState} from 'types/store';

import PostHeader, {type Props} from './post_header';

function mapStateToProps(state: GlobalState, ownProps: Props) {
    const user = getUser(state, ownProps.post.user_id);
    const isBot = Boolean(user && user.is_bot);

    return {
        overrideUsername: getPostOverrideUsername(state, ownProps.post),
        overrideIconURL: getPostOverrideIconURL(state, ownProps.post),
        isBot,
    };
}

export default connect(mapStateToProps)(PostHeader);
